import { Nomenclature } from './Nomenclature';
import { Instance } from './Instance';
import { Lawyer } from './Lawyer';
import { Person } from './Person';
import { FrxBaseBean } from './frxbasebean';
import { Izpulnitelno } from './izpulnitelno';
import { Nakazatelno } from './nakazatelno';

export class Case extends FrxBaseBean {

	applicationNumber: string;
	caseNumber: string;
	damageNumber: string;
	cost: number;
	chastichenIsk: number;
	costProperty: number;
	claimCost: number;
	claimCostProperty: number;
	claimNumber: string;
	traumas: string;
	date;
	mjastoPTP: string;
	claimDate;

	claimentList: Array<Person>;
	defendantList: Array<Person>;
	helpersList: Array<Person>;
	deadList: Array<Person>

	lawyer: Lawyer;
	claimResponsible: Lawyer;
	damageType: Nomenclature;
	traumaType: Nomenclature;
	izpulnitelnoDelo: Izpulnitelno;
	nakazatelnoDelo: Nakazatelno;

	mediator: string;
	percentage: number;

	constructor() {
		super();
		this.izpulnitelnoDelo = new Izpulnitelno();
		this.nakazatelnoDelo = new Nakazatelno();
		this.claimentList = new Array<Person>();
		this.defendantList = new Array<Person>();
		this.helpersList = new Array<Person>();
		this.deadList = new Array<Person>();
	}

	copy(source: Case) {
		super.copy(source);

		this.applicationNumber = source.applicationNumber;
		this.caseNumber = source.caseNumber;
		this.damageNumber = source.damageNumber;
		this.cost = source.cost;
		this.chastichenIsk = source.chastichenIsk;
		this.claimCost = source.claimCost;
		this.claimNumber = source.claimNumber;
		this.claimCostProperty = source.claimCostProperty;
		this.costProperty = source.costProperty;
		this.date = source.date;
		this.mjastoPTP = source.mjastoPTP;
		this.claimDate = source.claimDate;
		this.traumas = source.traumas;

		this.defendantList = source.defendantList;
		this.claimentList = source.claimentList;
		this.helpersList = source.helpersList;
		this.deadList = source.deadList;

		this.lawyer = source.lawyer;
		this.claimResponsible = source.claimResponsible;
		this.damageType = source.damageType;
		this.traumaType = source.traumaType;
		this.izpulnitelnoDelo = source.izpulnitelnoDelo;
		this.nakazatelnoDelo = source.nakazatelnoDelo;

		this.mediator = source.mediator;
		this.percentage = source.percentage;

	}
}
